import React from "react";
import SectionHeader from "./SectionHeader";
import ScrollCarousel from "./ScrollCarousel";
import { OFFERS } from "../mock";

// "Special Offer" — fixed-width (274px) product cards in a native scroll-snap
// track (clamps cleanly at both ends, no trailing space).
export default function SpecialOffers() {
  return (
    <section className="v2-section" id="special-offers-v2">
      <SectionHeader title="Special Offer" subtitle="Don't miss out on this limited-time deal!" viewAllHref="/web" />
      <ScrollCarousel trackClassName="v2-offers__track" step={290}>
        {OFFERS.map((offer) => (
          <div className="v2-offer-card" key={offer.id}>
            <div className="v2-offer-card__media">
              <img src={offer.image} alt={offer.title} />
              <span className="v2-offer-card__badge">{offer.badge}</span>
              <img className="v2-offer-card__brand" src={offer.brandLogo} alt="Brand" />
            </div>
            <div className="v2-offer-card__body">
              <div className="v2-offer-card__loc">
                {offer.location} <span className="v2-offer-card__dot">•</span> from {offer.from}
              </div>
              <h3 className="v2-offer-card__title">{offer.title}</h3>
              {offer.guaranteed && <span className="v2-offer-card__tag">Guaranteed Departure</span>}
              <div className="v2-offer-card__pricing">
                <span className="v2-offer-card__from">From <span className="v2-offer-card__orig">{offer.originalPrice}</span></span>
                <span className="v2-offer-card__save-tag">Save {offer.save}</span>
              </div>
              <div className="v2-offer-card__price">{offer.price} <span>/ person</span></div>
            </div>
          </div>
        ))}
      </ScrollCarousel>
    </section>
  );
}
